import { Component, inject, OnInit } from '@angular/core';
import { HeadService } from '../../../../services/head.service';
import { LanguageService } from '../../../../services/language/language.service';
import { WishlistItemDto } from '../../../../dtos/wishlist-item.dto';
import { CustomerService } from '../../../../services/customer.service';
import { environment } from '../../../../../environments/environment';
import { finalize } from 'rxjs/operators';
import { NotyService } from '../../../../components/noty/noty.service';
import { DEFAULT_ERROR_TEXT } from '../../../../constants';
import { GoogleAnalyticsService } from '../../../../services/google-analytics.service';

import { RouterLinkWithLang } from '../../../../directives/router-link-with-lang/router-link-with-lang.directive';
import { PreloaderComponent } from '../../../../components/preloader/preloader.component';
import { TranslatePipe } from '@ngx-translate/core';
import { RouterLink } from '@angular/router';

@Component({
    selector: 'wishlist',
    templateUrl: './wishlist.component.html',
    styleUrls: ['./wishlist.component.scss'],
  imports: [PreloaderComponent, TranslatePipe, RouterLink, RouterLinkWithLang],
})
export class WishlistComponent implements OnInit {
  private headService = inject(HeadService);
  private languageService = inject(LanguageService);
  private customerService = inject(CustomerService);
  private notyService = inject(NotyService);
  private analyticsService = inject(GoogleAnalyticsService);


  error: string;
  isLoading: boolean;
  uploadedHost = environment.uploadedHost;
  wishlist: WishlistItemDto[];

  ngOnInit(): void {
    this.setMeta();
    this.getWishlist();
  }

  public getWishlist() {
    this.error = null;
    this.wishlist =  this.customerService.customer.wishlist
      ?.sort((a, b) => (new Date(b.createTime) as any) - ( new Date(a.createTime) as any));
    this.wishlist.forEach((wishItem) => wishItem.isInWishlist = true);
  }

  private setMeta() {
    this.languageService.getTranslation('global.my_wishes').subscribe(text => {
      this.headService.setMeta({ title: text, description: text });
    });
  }

  addToCart(item: WishlistItemDto) {
    item.isLoading = true;
    this.customerService.addToCart(item.sku, 1)
      .pipe( finalize(() => item.isLoading = false) )
      .subscribe(
        () => {},
        error => this.notyService.error(error.error?.message || DEFAULT_ERROR_TEXT)
      );

    this.analyticsService.addToCart(item.sku, item.name, item.price, `Wishlist products`);
  }

  getWishlistItemThumbnail(product: WishlistItemDto) {
    if (!product.medias) {
      return '/assets/images/no-img.jpg';
    } else {
      return this.uploadedHost + product.medias;
    }
  }

   toggleWishlistFlag(item: WishlistItemDto) {
    this.customerService.toggleWishlistFlag(item.productId, item);
  }
}
